import { useEffect, useState } from 'react';
import { Modal } from './Modal';
import { Button } from '../ui';

/** Popup de entrada de texto (substitui o prompt() nativo) — criar arquivo/pasta, renomear. */
export function PromptModal({
  open,
  title,
  label,
  initial = '',
  placeholder,
  confirmLabel = 'Criar',
  onConfirm,
  onClose,
}: {
  open: boolean;
  title: string;
  label?: string;
  initial?: string;
  placeholder?: string;
  confirmLabel?: string;
  onConfirm: (value: string) => void;
  onClose: () => void;
}) {
  const [value, setValue] = useState(initial);
  useEffect(() => { if (open) setValue(initial); }, [open, initial]);

  function submit() {
    const v = value.trim();
    if (v) onConfirm(v);
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      width={460}
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>Cancelar</Button>
          <Button variant="primary" onClick={submit} disabled={!value.trim()}>{confirmLabel}</Button>
        </>
      }
    >
      {label && <div style={{ fontSize: 13, marginBottom: 6, color: 'var(--muted)' }}>{label}</div>}
      <input
        autoFocus
        value={value}
        placeholder={placeholder}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); submit(); } }}
        style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid var(--border, #333)', background: 'var(--bg, #111)', color: 'inherit', fontSize: 14, boxSizing: 'border-box' }}
      />
    </Modal>
  );
}
